export default __webpack_public_path__ + "static/media/sendProfilePhoto.97c4791d.png";